import React, { useState } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import "./app.css";
import { Myinput, Mylogo, ModalDetailforget } from "../Useful/Useful";
import Raeenlogo from "../../img/maloos-logo.png";
import web from "../../img/web.jpg";
import { Button, Form } from "reactstrap";
import "react-awesome-slider/dist/styles.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ForgetPass } from "../../fetch";
import { useHistory } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function SimpleModal(props) {
  const classes = useStyles();
  const history = useHistory();
  const [pass, setPass] = useState("");
  const [openModal, setopenModal] = useState(false);

  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);

  const handleOpen = () => {
    setopenModal(true);
  };

  const handleClose = () => {
    setopenModal(true);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <h2 id="simple-modal-title">رمز عبور جدید به شماره تماس ارسال شد </h2>
      {/* <p id='simple-modal-description'>{pass}</p> */}

      <Link to="/login">
        <Button
          color="primary"
          className="btn btn-info btn-lg"
          id="regProdbtn"
          //   onClick={() => {
          //     setId(item.id);
          //   }}
        >
          تایید
        </Button>
      </Link>

      {/* <SimpleModal /> */}
    </div>
  );

  function handleSubmit(e) {
    e.preventDefault();
    // if (e.target.phoneNumber.value === "" || e.target.password.value === "") {
    //   toast.error("نام کاربری یا کلمه عبور وارد نشده است");
    //   return false;
    // }
    if (!e.target.phoneNumber.value) {
      toast.error("لطفا شماره تماس را وارد کنید");
    }

    ForgetPass({
      PhoneNumber: e.target.phoneNumber.value,
      //   password: e.target.password.value,
    })
      .then((response) => {
        if (response.status == 200) {
          setopenModal(true);
        } else {
          toast.error(response);
        }

        return response.json();
      })
      .then((responseJson) => {
        toast.error(responseJson.message);
        //  history.push("/MailListItem");
      })
      .catch((error) => {
        console.log(error.response.body.message);
        toast.error(error.response.body.message);
        return false;
      });
  }

  return (
    <div class="col-12 backLogin">
      <div class="row">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 col-md-8 col-sm-12 col-xs-12 menuLogin shadow  ">
          <div class="row ">
            <div class="col d-flex justify-content-center align-center ">
              <Form onSubmit={handleSubmit}>
                <Mylogo class="logoSize" src={Raeenlogo} alt="logo" />
                <h5> ارسال رمز عبور جدید</h5>
                <Myinput
                  id="phoneNumber"
                  name="شماره همراه"
                  type="number"
                  placeholder="شماره همراه..."
                />
                {/* <Myinput name='کلمه عبور' id='password' type='password' /> */}

                <Button color="primary" size="sm" id="loginidbtn" type="submit">
                  ارسال
                </Button>

                {/* <Modal open={openModal} /> */}

                <div>
                  {/* <button type='button' onClick={handleOpen}>
                    Open Modal
                  </button> */}
                  <Modal
                    open={openModal}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                  >
                    {body}
                  </Modal>
                </div>
              </Form>
            </div>
          </div>
          {/* <Link to='/login'>بازگشت به صفحه ورود</Link> */}
        </div>
        <div class="col-lg-3"></div>
      </div>
    </div>
  );
}
